module.exports = __webpack_public_path__ + "img/user_orig.png";